import React, { Component, Fragment } from "react"
import PropTypes from "prop-types"
import { observer } from "mobx-react"
import { Table } from "semantic-ui-react"
import _ from "lodash"
import ProductRowDefault from "components/Product/ProductRowDefaultReturnReadOnly"
import Responsive                                                from "react-responsive"
import shop from "shop/shop"

@observer
export default class ProductTable extends Component {
  static propTypes = {
    list    : PropTypes.object,
    cart    : PropTypes.object,
    onChange: PropTypes.func,
    products: PropTypes.array,
  }
  
  render() {
    let { list, cart, products, onChange } = this.props
    let ProductRow = this.props.row || ProductRowDefault
    let positions = list || products
    if ( list ) positions = list.products
    let rows = _.map( positions, ( product, index ) => {
      return (
        <ProductRow key={index} index={index} onChange={onChange} list={list} cart={cart} product={product}/>
      )
    } )
    return (
      <div>
        <Responsive maxWidth={790}>
          <table>

            <tbody>
            {rows}
            </tbody>
          </table>
        </Responsive>
        <Responsive minWidth={790}>
        <Table className="TableCustData" >
            <colgroup>
                <col width="50%"/>
                <col width="15%"/>
                {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" && <col width="15%"/>}
                {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" && <col width="15%"/>}

                <col width="5%"/>
                <col width="10%"/>
            </colgroup>
            <Table.Header>
                <tr>
                    <th className="tr">{translate( "Artikel" )}</th>
                    {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.rewe_extra && shop.session.value.extras.rewe_extra == "Ja" && <th className="tl">{translate( "REWE NAN" )}</th>}
                    {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.edeka_extra && shop.session.value.extras.edeka_extra == "Ja" && <th className="tl">{translate( "EDEKA Art-Nr." )}</th>}
                    <th className="tl">EAN</th>
                    <th style={{alignContent:"right",textAlign:"right"}} className="tl">&nbsp;</th>
                    <th style={{alignContent:"right",textAlign:"left"}} className="tr">{translate( "Restanten" )}</th>
                    {/*<th style={{alignContent:"right",textAlign:"right"}} className="tr">{translate( "UVP" )}</th>*/}
                </tr>
            </Table.Header>
            <tbody>
            {rows}
            </tbody>
        </Table>
        </Responsive>
      </div>
    )
  }
}







// WEBPACK FOOTER //
// ./src/theme/lindt/components/Product/ProductTableReturnReadOnly.js